export default "__VITE_ASSET__XADZDQuv__"